export default {
  ROLE_MUTATIONS(state, { key, value }) {
    state[key] = value;
  },
};
